export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString("de-DE", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export function isInvalidMultilevelRoseEntry(conditionData) {
  if (!Array.isArray(conditionData) || conditionData.length === 0) {
    return true;
  }
  const firstEntry = conditionData[0];
  if (Array.isArray(firstEntry)) {
    if (Array.isArray(firstEntry[2]) && firstEntry[2].length === 0) {
      return true;
    }
  }
  return false;
}

export const getExpoList = (expos) => {
  if (!expos || !Array.isArray(expos)) {
    return [];
  }
  return expos
    .filter((expoEntry) => expoEntry && expoEntry.expo != null)
    .map((expoEntry) => expoEntry.expo);
};

export const getTitle = (item) => {
  const locale = "de";
  const enTitle = item.title_en || item.title;
  return locale === "de" ? item.title : enTitle;
};

export const getContent = (item) => {
  const locale = "de";
  const enContent = item.content_en || item.content;
  return locale === "de" ? item.content : enContent;
};

export function getAutorLink(fn, ln) {
  if (fn == "Lukas" && ln == "Ruetz") {
    return "https://www.lukasruetz.at";
  }
  if (fn == "Kristian" && ln == "Rath") {
    return "https://freieberge.wordpress.com";
  }
  if (fn == "Markus" && ln == "Stadler") {
    return "https://www.stadler-markus.de";
  }
  if (fn == "Daniel" && ln == "Kleinlercher") {
    return "https://www.freerideschule-kleinlercher.at";
  }
  if (fn == "Günter" && ln == "Chwojan") {
    return "https://www.sevensummits.at";
  }
  if (fn == "Josef" && ln == "Hümmer") {
    return "https://www.die-bergfuehrer.de";
  }
  return null;
}

export const snowIconLabels = {
  pulverschnee: "Pulverschnee",
  firn: "Firn",
  bruchharsch: "Bruchharsch",
  faulschnee: "Faulschnee",
  vereist: "Vereist",
  harschdeckel: "Tragfähiger Harschdeckel",
  sommerschnee: "Sommerschnee",
  noppenpulver: "Noppenpulver",
  windbeeinflusst: "Windbeeinflusster Schnee",
  wechselhafterschnee: "Wechselhafter Schnee",
  nassschnee: "Nassschnee",
  aper: "Aper",
};

export const avalancheIconLabels = {
  newsnow: "Neuschnee",
  windslab: "Triebschnee",
  weaklayer: "Altschnee",
  wetsnow: "Nassschnee",
  glidesnow: "Gleitschnee",
};

export const getGradeOfManageability = (grade) => {
  if (!grade) {
    return 0;
  }
  if (grade == "leicht") {
    return 1;
  }
  if (grade == "schwierig") {
    return 2;
  }
  if (grade == "kompliziert") {
    return 3;
  }
  return 0;
};

export const getGradeOfManageabilityLabel = (grade) => {
  if (grade == "leicht") {
    return "Einfache Lawinensituation";
  }
  if (grade == "schwierig") {
    return "Schwierige Lawinensituation";
  }
  if (grade == "kompliziert") {
    return "Heimtückische Lawinensituation";
  }
  return "";
};

export function formatTimestampToUserLocale(timestamp, withTime = false) {
  const date = new Date(timestamp);

  let options = {
    // Optional: 'timeZone': 'Europe/Berlin',
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  if (withTime) {
    options = {
      // Optional: 'timeZone': 'Europe/Berlin',
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
  }
  return date.toLocaleString("de", options);
}
